import ImageGallery from './ImageGallery'

export { ImageGallery as default }
